import { Injectable, Injector } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TimeSheetsStore } from 'projects/desktop/src/app/modules/timesheets/data/time-sheets.store';
import { HttpService, cacheResult } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';
import { ProjectSales } from './project-sales';
import { ProjectSale } from './project-sale';
import { Memoize } from 'projects/core/src/lib/core/utils/decorators/memoize-decorator';
import { QBClass } from './qb-class';
import { QBServ } from './qb-serv';
import { Any } from 'json2typescript';
import { QBFile } from './qb-file';
import { CalendarEstimateSale } from 'projects/app-misc/src/app/modules/qb/data/calendar-estimate-sale';

@Injectable({
  providedIn: 'root'
})
export class QBService extends HttpService {

  public newInvoice$ = new Subject<ProjectSale>();

  constructor(
    protected injector: Injector,
    protected timeSheetsStore: TimeSheetsStore
  ) {
    super(injector);
  }

  createEstimate(projectId: number, amount: number): Observable<ProjectSale> {
    return this.postData(`/qb/estimate/list/for-project?amount=${amount}&projectId=${projectId}`, {}, ProjectSale)
  }

  createInvoiceForEstimate(projectId: number, estimateId: string, percent: number, useRemain = false): Observable<ProjectSale> {
    return this.postData(`/qb/invoices/list/for-project?amount=0&useRemain=${useRemain}&projectId=${projectId}&estimateId=${estimateId}&percent=${percent}`, {}, ProjectSale)
  }

  createInvoice(projectId: number, amount: number, useRemain = false): Observable<ProjectSale> {
    return this.postData(`/qb/invoices/list/for-project?amount=${amount}&projectId=${projectId}&useRemain=${useRemain}`, {}, ProjectSale)
  }

  getSalesForProject(projectId: number): Observable<ProjectSales> {
    return this.getData(`/qb/sales/for-project?projectId=${projectId}`, ProjectSales)
  }

  sendInvQB(id: string): Observable<ProjectSale> {
    return this.putData(`/qb/invoices/${id}/send-email`, {}, ProjectSale)
  }

  sendEstQB(id: string): Observable<ProjectSale> {
    return this.putData(`/qb/estimate/${id}/send-email`, {}, ProjectSale)
  }

  updateSale(sale: ProjectSale): Observable<ProjectSale> {
    if(sale.type === 'Estimate') {
      return this.putData(`/qb/estimate`, sale, ProjectSale)
    }
    if(sale.type === 'Invoice') {
      return this.putData(`/qb/invoice`, sale, ProjectSale)
    }

  }

  getDeliveredProjectEstimatesTotal(startDate: string, endDate: string): Observable<CalendarEstimateSale> {
    return this.getData(`/qb/estimate/list/sold-stats/${startDate}:${endDate}`, CalendarEstimateSale)
  }

  getQBClasses(): Observable<QBClass> {
    return this.getData(`/qb/class/list`, QBClass)
  }

  getQBServices(): Observable<QBServ> {
    return this.getData(`/qb/products-services/list`, QBServ)
  }

  getQBFiles(type: string, id: string): Observable<QBFile[]> {
    return this.getData(`/qb/attachments/list?type=${type}&txnId=${id}`, QBFile)
  }

  deleteEstimate(id: string): Observable<ProjectSale> {
    return this.deleteData(`/qb/estimate/${id}`, ProjectSale)
  }

  deleteInvoice(id: string): Observable<Any> {
    return this.deleteData(`/qb/invoices/${id}`, Any)
  }

}
